import { useEffect, useState } from 'react';
import {
  DataStoreFlags,
  getDataStoreFlags,
} from 'shared/services/flags.service';

export const useDataStoreFlags = () => {
  const [flags, setFlags] = useState<DataStoreFlags | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getDataStoreFlags()
      .then((data) => {
        if (!cancelled) setFlags(data ?? {});
      })
      .catch(() => {
        if (!cancelled) setFlags({});
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { flags, isLoading };
};
